import * as Sentry from '@sentry/vue'
import store from '@/vuex/store'
import Config from '@/config'

const loadDataFromSlidePowerPoint = async (key) => {
  if (!window.Office) return null
  if (!window.Office.context) return null
  if (!window.Office.context.host) return null
  return new Promise((resolve, reject) => {
    window.Office.context.document.settings.refreshAsync((asyncResult) => {
      if (asyncResult.status === window.Office.AsyncResultStatus.Failed) {
        reject()
      } else {
        const ahaSlideId = window.Office.context.document.settings.get(key)
        if (ahaSlideId !== null) {
          resolve(ahaSlideId)
        } else {
          resolve()
        }
      }
    })
  })
}

const setDataSlideInPowerpointToState = (ahaPresentationId, ahaSlideId) => {
  store.state.powerPointPresentationId = ahaPresentationId
  store.state.powerPointSlideId = ahaSlideId
}

const setDataPresentationInPowerpointToState = (ahaPresentationId) => {
  store.state.activePresentationPowerpointId = ahaPresentationId
}

const handleOnLoadOffice = async () => {
  if (window.Office && window.Office.context && window.Office.context.host) {
    store.state.isPowerPointAddIn = true
    const dataSlidePPT = await loadDataFromSlidePowerPoint('dataSlidePPT')
    if (dataSlidePPT && dataSlidePPT.activePresentationId) {
      setDataPresentationInPowerpointToState(dataSlidePPT.activePresentationId)
      if (window.location.href.indexOf('/presentation/') === -1) {
        window.location.href = `${Config.presenterDomain}/presentation/${dataSlidePPT.activePresentationId}?presenting=true&ppt-presentation=true`
      }
      return
    }
    if (dataSlidePPT && dataSlidePPT.slideId && dataSlidePPT.presentationId) {
      setDataSlideInPowerpointToState(dataSlidePPT.presentationId, dataSlidePPT.slideId)
      if (window.location.href.indexOf('/presentation/') === -1) {
        window.location.href = `${Config.presenterDomain}/presentation/${dataSlidePPT.presentationId}?presenting=true`
      }
    }
  }
}

const loadOffice = async () => {
  try {
    if (window.Office) {
      return window.Office
    }
    const loadOfficePromise = async () => {
      return new Promise((resolve, reject) => {
        const script1 = document.createElement('script')
        script1.onload = async () => {
          window.Office.onReady(() => {

          })
          setTimeout(async () => {
            await handleOnLoadOffice()
            resolve(window.Office)
          }, 1000)
        }
        script1.onerror = reject
        script1.src = 'https://appsforoffice.microsoft.com/lib/1/hosted/office.js'
        document.head.appendChild(script1)
      })
    }
    await loadOfficePromise()
    return window.Office
  } catch (error) {
    Sentry.captureException(error)
    return null
  }
}

const saveDataToSlidePowerPoint = async (key, value) => {
  if (window.Office && window.Office.context && window.Office.context.host) {
    window.Office.context.document.settings.set(key, value)
    if (!value) {
      window.Office.context.document.settings.remove(key)
      window.Office.context.document.settings.set(key, '')
      window.Office.context.document.settings.saveAsync(() => {
      })
    }
    return new Promise((resolve, reject) => {
      window.Office.context.document.settings.saveAsync((asyncResult) => {
        if (asyncResult.status === window.Office.AsyncResultStatus.Failed) {
          reject()
        } else {
          resolve()
        }
      })
    })
  }
  return null
}

export default {
  loadOffice,
  saveDataToSlidePowerPoint,
  loadDataFromSlidePowerPoint,
  setDataSlideInPowerpointToState,
  setDataPresentationInPowerpointToState,
}
